// extracted by mini-css-extract-plugin
module.exports = {"ariaLive":"src-hellospa-common-hooks-use-aria-live__ariaLive--2BDUJ"};